module.exports = __webpack_public_path__ + "static/media/ftt-background.0eb31a4f.jpg";